import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import DocumentBrowseCardLabel from './DocumentBrowseCardLabel';
import DocumentBrowseCardLink from './DocumentBrowseCardLink';
import FavoritesRibbon from '../../../elements/FavoritesRibbon';
import Image from '../../../elements/Image';
import { getImageUrl } from '../../../../lib/cloudinary';
import utils from 'lib/utils';
import useAppContext from 'lib/hooks/useAppContext';

const DocumentBrowseImageWrapper = styled.div`
  flex: 0 0 auto;
  position: relative;
`;

const DocumentBrowseCardImage = ({
  dataAttrs,
  favoritableId = null,
  includeFavorite = false,
  isShop,
  label = null,
  lazyImage,
  photo,
  siteKey,
  title,
  url,
  visualStyle,
}) => {
  const { domainSiteKey } = useAppContext();
  const imgConfig = photo
    ? {
        aspectRatio: photo.aspect_ratio ? photo.aspect_ratio : '1:1',
        width: 150,
        ...(photo.config || {}),
      }
    : {};
  const imgId = photo.id || photo.public_id;

  const imgSrc = getImageUrl(imgId, 'thumbnail', imgConfig);
  return (
    <DocumentBrowseImageWrapper className="document-browse-card__image-wrapper">
      <DocumentBrowseCardLink
        {...dataAttrs}
        aria-hidden="true"
        href={utils.checkRelativeLink(domainSiteKey, url)}
        target={isShop ? '_blank' : '_self'}
        title={title}
      >
        <Image
          alt=""
          aspectRatio={imgConfig.aspectRatio}
          lazy={lazyImage}
          src={imgSrc}
        />
        {label ? (
          <DocumentBrowseCardLabel>{label}</DocumentBrowseCardLabel>
        ) : null}
      </DocumentBrowseCardLink>
      {visualStyle !== 'quick-view-card' && includeFavorite && favoritableId ? (
        <FavoritesRibbon
          favoritableId={favoritableId}
          favoritableSiteKey={siteKey}
          title={title}
        />
      ) : null}
    </DocumentBrowseImageWrapper>
  );
};

DocumentBrowseCardImage.propTypes = {
  dataAttrs: PropTypes.object.isRequired,
  favoritableId: PropTypes.string,
  includeFavorite: PropTypes.bool,
  isShop: PropTypes.bool.isRequired,
  label: PropTypes.string,
  lazyImage: PropTypes.bool.isRequired,
  photo: PropTypes.object.isRequired,
  siteKey: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  visualStyle: PropTypes.string.isRequired,
};

export default DocumentBrowseCardImage;
